import React, {Component} from 'react';
import ThemeProvider from 'react-toolbox/lib/ThemeProvider';

import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import * as SensorsActions from "../../../actions/sensors";
import * as SliderActions from "../../../actions/slider";
import * as PollutionAreasActions from "../../../actions/pollutionAreas";
import * as AppActions from "../../../actions/app";
import * as HeatmapActions from "../../../actions/heatmaps";
import * as AnalyticsActions from "../../../actions/analytics";
import * as NoiseActions from "../../../actions/noise";

import '../../../assets/react-toolbox/theme.css';
import theme from '../../../assets/react-toolbox/theme.js';

import {PanelBody} from './PanelBody'


class Index extends Component {
    constructor() {
        super();
        this.state = {}
    }

    render() {

        const dummyButtonText = !this.props.app.createSensors ? "Create Sensor Points" : "Stop Sensor Points";
        const hideButtonText = this.props.app.hideSensors ? "Show Sensors" : "Hide Sensors";
        const hideDummieIcon = this.props.app.hideSensors ? "visibility" : "visibility_off";
        const GraphDisabled = true;

        return (
            <ThemeProvider theme={theme}>
                <div>
                    <div className="adminPanelContainer hidden-xs">
                        <PanelBody
                            create={{
                                disabled: this.props.pollutionAreas.isClosed,
                                handle: () => this.props.pollutionAreasActions.creatingPollutionArea()
                            }}
                            delete={{
                                disabled: !this.props.pollutionAreas.isClosed || this.props.app.hideSensors,
                                handle: () => this.props.pollutionAreasActions.deletePollutionArea(this.props.map)
                            }}
                            createSensor={{
                                disabled: !this.props.pollutionAreas.isClosed || this.props.app.hideSensors,
                                handle: () => this.props.appActions.toggleCreateSensors(),
                                text: dummyButtonText
                            }}
                            deleteSensors={{
                                disabled: this.props.sensors.adminSensors.length === 0 || this.props.app.hideSensors,
                                handle: () => this.props.sensorsActions.deleteAllSensors()
                            }}
                            hideSensors={{
                                disabled: this.props.app.createSensors && this.props.sensors.adminSensors.length === 0,
                                handle: () => this.props.appActions.toggleSensors(),
                                text: hideButtonText,
                                icon: hideDummieIcon
                            }}
                            baseMask={{
                                disabled: !this.props.pollutionAreas.isClosed,
                                handle: () => this.props.pollutionAreasActions.generateBaseMask(this.props.map)
                            }}
                            heatMap={{
                                disabled: !this.props.pollutionAreas.isClosed, handle: () => {
                                    this.props.analyticsActions.removeAQI();
                                    this.props.heatmapsActions.generateHeatmap()
                                }
                            }}

                            GraphDisabled={GraphDisabled}
                            aqi={{
                                isDisabled: this.props.app.IoTsensor,
                                messages: this.props.analytics.historic.aqi,
                                xAxis: this.props.analytics.historic.time
                            }}
                            noise={{
                                isDisabled: this.props.noise.noiseChart,
                                value: this.props.noise.value,
                                time: this.props.noise.time
                            }}
                        />
                    </div>
                </div>
            </ThemeProvider>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        sensors: state.sensors,
        slider: state.slider,
        pollutionAreas: state.pollutionAreas,
        app: state.app,
        heatmaps: state.heatmaps,
        analytics: state.analytics,
        noise: state.noise
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        sensorsActions: bindActionCreators(SensorsActions, dispatch),
        sliderActions: bindActionCreators(SliderActions, dispatch),
        pollutionAreasActions: bindActionCreators(PollutionAreasActions, dispatch),
        appActions: bindActionCreators(AppActions, dispatch),
        heatmapsActions: bindActionCreators(HeatmapActions, dispatch),
        analyticsActions: bindActionCreators(AnalyticsActions, dispatch),
        noiseActions: bindActionCreators(NoiseActions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Index)



// WEBPACK FOOTER //
// ./src/components/Map/AdminAppBar/index.js